export default __webpack_public_path__ + "static/media/3.96770c04.png";